// @flow

import React from 'react';
import type { Node } from 'react';
import { BaseHeader } from '@riseart/layout';
import { CmsViewModule } from 'shared_hocs/cms/views/Module';
import Logo from 'shared_components/common/logo/Logo';
import { LayoutDefault } from 'shared_components/layouts/Default';

/**
 * QuizStartPage
 *
 * @returns {Node}
 */
export default function QuizStartPage(): Node {
  return (
    <LayoutDefault
      hasFooter={false}
      hasHeader
      headerComponent={<BaseHeader contentLeft={<Logo tag="h1" black />} />}
    >
      <CmsViewModule placeholder="cmsQuizStartContent" />
    </LayoutDefault>
  );
}
